exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Libre+Barcode+39&display=swap);", ""]);

// module
exports.push([module.id, ".MeskenDokum [data-v-9f226fc6]{font-family:IBM Plex Sans,sans-serif!important}.barkod[data-v-9f226fc6]{width:100%;display:block;height:80px}.barkod div[data-v-9f226fc6]{display:inline-block;float:left}.barkodbaski[data-v-9f226fc6]{font-family:Libre Barcode\\ 39,cursive!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f226fc6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Esayac/ElektrikLazer.vue
// module id = 1112
// module chunks = 0